import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";

import { title, decodeUnicodeBase64 } from "utils";

import { Header, Logo } from "components";
import { Button } from "antd";

class InvitationPage extends Component {
  render() {
    let error = false,
      submission = {};
    const { enc_submission } = this.props.match.params;
    if (!enc_submission) error = true;

    try {
      const dec = decodeUnicodeBase64(enc_submission);
      submission = JSON.parse(dec);
    } catch (e) {
      error = true;
      submission = {};
    }

    // submission.user_name = 'test test'
    // submission.user_mail = 'test test'

    return (
      <Fragment>
        <Helmet>{title("Invitation CLB")}</Helmet>
        <div className="invitation-page-wrap main-content">
          <div className="invitation-page">
            <div className="contacts">
              <Logo colors />
              <p>
                <span>680 avenue Jean Demers</span>
                <span>Bécancour (Québec)</span>
                <span style={{ marginBottom: 10 }}>G9H 3A3</span>
                <span>Tél. (819) 294-2811</span>
                <a href="mailto:info@clbinc.com">info@clbinc.com</a>
              </p>
            </div>

            <Header title="Invitation à soumissionner" />
            {error ? (
              <>
                <h2>Une erreur est survenue...</h2>
                <p>Le lien qui vous a été fournie n'est peut-être plus valide.</p>
                <p>
                  Vous pouvez nous contacter pour des tenter de résoudre le problème :{" "}
                  <a href="mailto:info@clbinc.com" target="_blank">
                    info@clbinc.com
                  </a>
                </p>
              </>
            ) : (
              <>
                <p>
                  Construction Lavigne & Baril vous invite à fournir un prix, dans votre discipline
                  (spécialité), pour le projet suivant :
                </p>
                <ul className="details">
                  <li>
                    <label>Projet :</label>
                    <b>{submission?.title}</b>
                  </li>
                  <li>
                    <label>Propriétaire (client) :</label>
                    <b>{submission?.client_name}</b>
                  </li>
                  <li>
                    <label>Fermeture des généraux :</label>
                    <b>{submission?.date_depot || "-"}</b>
                  </li>
                  <li>
                    <label>Localisation :</label>
                    <b>{submission?.region}</b>
                  </li>
                </ul>

                <p>
                  Pour vous procurer les documents de soumission, veuillez utiliser les indications
                  inscrites dans le courriel de la présente invitation.
                </p>

                {submission?.user_name && submission?.user_mail ? (
                  <>
                    <br />
                    <p>
                      <b>
                        Pour toutes questions, veuillez contacter :{" "}
                        <a href={"mailto:" + submission.user_mail} target="_blank">
                          {submission.user_name}
                        </a>
                      </b>
                    </p>
                  </>
                ) : (
                  <></>
                )}

                <br />
                <br />
                <p>
                  SVP nous transmettre votre soumission, en indiquant les sections de devis
                  soumissionnées ainsi que les addenda inclus à votre prix. Veuillez remplir le
                  bordereau du client svp.
                </p>

                <br />
                <small>Notes importantes:</small>
                <ul className="list">
                  <li>
                    Les conditions générales du devis s’appliquent à tous les sous-traitants.
                    Ceux-ci sont disponible dans l’ensemble des documents ou sur demande. Soyez
                    avisés que le fait de nous soumettre un prix implique que vous acceptez de vous
                    conformer à toute clause du devis concernant la sous-traitance et tout
                    particulièrement, mais sans s’y limiter, les exigences en matière d’assurances,
                    d’horaires de travail, de conditions de paiement, d’échéancier des travaux et de
                    santé et sécurité au travail.
                  </li>
                  <li>
                    Les soumissionnaires sont responsables de vérifier la disponibilité des
                    addendas. Tous les documents sont mis à votre disposition sur notre site, dès
                    leur réception.
                  </li>
                  <li>Validité de votre soumission: tel que devis.</li>
                </ul>

                <p className="ref">Référence No. soumission CLB: {submission?.id}</p>
              </>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default InvitationPage;
